<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="!isMentor ? 'Bimbingan '+title : 'Validasi ' + title">
            <br>
            <a-card type="inner" size="small">
                <a-row type="flex">
                    <a-col :span="24">
                        <a-descriptions bordered>
                            <a-descriptions-item label="Nama Pelatihan">
                                <strong>{{ trainingInfo.title }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Tanggal Pelatihan">
                                <strong>{{ moment(trainingInfo.date_start).format('DD MMMM YYYY') }} s.d {{ moment(trainingInfo.date_end).format('DD MMMM YYYY') }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Deskripsi">
                                <strong>{{ trainingInfo.description }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Peserta">
                                <strong>{{ items.attendants_count }}</strong>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
            </a-card>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="tableColumns"
                :dataSource="addData"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="outline" slot-scope="record" style="text-align: left">
                    <strong>{{ record.title }}</strong><br>
                    {{ record.description }}
                </div>

                <div slot="attendants" slot-scope="record">
                    {{ record.outline_attendant_count }}
                </div>

                <div slot="approve" slot-scope="record">
                    {{ record.approved_outline_count }}
                </div>

                <div slot="action" slot-scope="record">
                    <a-button size="small" block @click="approval(record.hash)">
                        <div v-if="record.hash != 'Presentasi' && record.hash != 'Revisi'">
                            <div v-if="isMentor">
                                VALIDASI
                            </div>
                            <div v-else>
                                APPROVAL
                            </div>
                        </div>
                        <div v-else>
                            VIEW
                        </div>
                    </a-button>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'outline',
            title: 'Outline',
            align: 'center',
            scopedSlots: {customRender: 'outline'},
        }, {
            key: 'attendants',
            title: 'Upload Bimbingan',
            align: 'center',
            scopedSlots: {customRender: 'attendants'}
        }, {
            key: 'approve',
            title: 'Approve Bimbingan',
            align: 'center',
            scopedSlots: {customRender: 'approve'}
        }, {
            key: 'action',
            title: 'Action',
            align: 'center',
            scopedSlots: {customRender: 'action'}
        }
    ]

    export default {
        props: {
            outline: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                columns,
                items: {
                    outlines: [
                        {
                            presentation_count: '0',
                            revision_count: '0'
                        }
                    ],
                    activity: {},
                },
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        computed: {
            trainingInfo(){
                return this.$laravel.training
            },
            activeModule() {
                return this.$laravel.active_module
            },
            addData() {
                this.items.outlines.push(
                    {
                        title: 'PRESENTASI & ' + this.title.toUpperCase(),
                        description: 'Presentasi & ' + this.title,
                        approved_outline_count: '0',
                        outline_attendant_count: this.items.outlines[0].presentation_count,
                        hash: 'Presentasi'
                    }
                )
                this.items.outlines.push(
                    {
                        title: 'REVISI PRESENTASI & ' + this.title.toUpperCase(),
                        description: 'Revisi Presentasi & ' + this.title,
                        approved_outline_count: '0',
                        outline_attendant_count: this.items.outlines[0].revision_count,
                        hash: 'Revisi'
                    }
                )
                return this.items.outlines
            },
            title(){
                switch(this.outline) {
                    case "proposal":
                        return "Proposal"
                    case "project_evaluation":
                        return "Evaluasi Project"
                    case "evaluation":
                        return "Evaluasi Kinerja"
                    default:
                        return "Makalah"
                }
            },
            role(){
                return this.$laravel.roles[this.activeModule.module.identifier]
            },
            isMentor() {
                return this.role == 'mentor'
            },
            tableColumns() {
                if(this.isMentor)
                    this.columns[2].title = "Validasi Bimbingan"
                return this.columns
            }
        },
        methods: {
            getItems() {
                this.loading = true;

                let params = this.activeModule.module.identifier == 'paper' || this.activeModule.module.identifier == 'evaluation' ? null : {
                    params: {
                        outline: this.outline
                    }
                }

                this.$http
                    .get(this.routeUri("api.activity.guidance.summary"), params)
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            download(url) {
                window.open(window.location.origin + url, '_blank')
            },
            approval(hash){
                if(hash == 'Presentasi' || hash == 'Revisi'){
                    let type = hash
                    hash = this.items.outlines[0].hash
                    let params = {
                        outline: this.outline,
                        hash: hash,
                        type: type
                    }
                    window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.' + this.outline +'.attendants.final') + '?' + this.$qs.stringify(params)
                }else{
                    let params = {
                        outline: this.outline,
                        hash: hash
                    }

                    window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.' + this.outline +'.attendants') + '?' + this.$qs.stringify(params)
                }
            },
        }
    }
</script>
